module.exports = __webpack_public_path__ + "static/img/moaInstallForMac_pic16.73ef0d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForMac/moaInstallForMac_pic16.png
// module id = 534
// module chunks = 1